import React from 'react';

const Facebook = () => {

    return <div className="fb-tab-deprecation-notice">
        <h2>DEPRECIATION NOTICE/UPDATE</h2>

        <p>
            Earlier this year Facebook announced that as of August 1st, 2018, software that uses their live API to publish on behalf of its users must be granted special permission, and follow new requirements.
            <a href="https://developers.facebook.com/blog/post/2018/04/24/new-facebook-platform-product-changes-policy-updates/">Read the official Facebook announcement here.</a>
        </p>

        <p className="fb-tab-prompt">
            How does this affect me?
        </p>

        <p>
            Streaming to live events has been permanently deprecated by Facebook. Because of the heightened restrictions on the use of the Facebook API, Invintus re-submitted our Facebook Live feature for review based in the new rules in early July 2018. <em>Currently Facebook has since not reviewed or released our changes to be in compliance with their new rules.</em> As a result, we are currently no longer able to automatically publish posts (or FB events) to Facebook using their live API. Backlogs at Facebook are reported to be over two months for app review at this time. As a result of being now past the deadline of August 1st, the Publish direct to Facebook Live feature will no longer be available until this is resolved.
        </p>

        <p className="fb-tab-prompt">
            What are we doing to fix this?
        </p>

        <p>
            We know that streaming to Facebook Live is important to you, so to lessen the impact of these Facebook restrictions we are releasing a new method of streaming to Facebook, as well as adding the ability to stream live to YouTube, Twitter and other alternate RTMP destinations in a similar way. This release date of this feature is expected in early September 2018.
        </p>

        <p className="fb-tab-prompt">
            How will this change work?
        </p>

        <p>
            Scheduling your Facebook event and creating titles and descriptions will need to be completed within the Facebook website and the server and stream key information will need to be copy/pasted to the corresponding event created in the Invintus Control Center. How To videos will be posted in the upcoming "social streaming" section of the Control Center. As always, please feel free to <a href="mailto:support@invintus.com">contact us</a> should you have any additional questions.
        </p>

        <p className="fb-tab-signature">
            Sincerely,<br />
            The Invintus Team
        </p>

    </div>;
}


export default Facebook;
